import React from "react";
import { LeftSideContainer } from "styles/pages/global";
const LeftContainer = () => {
  return (
    <LeftSideContainer>
    </LeftSideContainer>
  );
};

export default LeftContainer;
